"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.footballConfig = {
    clock: {
        direction: 'up',
        endPeriodType: 'injuryTime',
        cumulative: true
    }
};
//# sourceMappingURL=sportConfig.js.map